import React, { useEffect, useRef } from 'react';
import './Footer.css';
// Logo import (Ensure your image is in src/assets or public folder)
import logo from '../../assets/images/logo1.png'; 

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animation trigger
            entry.target.classList.add('footer-reveal-active');
          } else {
            // Reset animation jab user upar scroll kare (Repeat effect)
            entry.target.classList.remove('footer-reveal-active');
          }
        });
      },
      { threshold: 0.1 } // 10% footer dikhte hi start hoga
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Smooth scroll function
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-main-container" ref={footerRef}>
      <div className="container">
        <div className="footer-grid">
          
          {/* Brand Section */}
          <div className="footer-col brand-info">
            <img src={logo} alt="Sentosa Era Logo" className="footer-brand-logo" />
            <p className="brand-tagline">Experience Luxury Living</p>
          </div>

          {/* Links Section - Smooth Scroll ID's */}
          <div className="footer-col quick-links">
            <h3>Useful Links</h3>
            <ul>
              <li onClick={() => scrollToSection('home')}>Home</li>
              <li onClick={() => scrollToSection('about')}>About</li>
              <li onClick={() => scrollToSection('highlights')}>Key Highlights</li>
              <li onClick={() => scrollToSection('pricing')}>Pricing & Floor Plan</li>
              <li onClick={() => scrollToSection('amenities')}>Amenities</li>
              <li onClick={() => scrollToSection('contact')}>Contact</li>
            </ul>
          </div>

          {/* Contact Details Section */}
          <div className="footer-col footer-address">
            <h3>Address</h3>
            <p className="addr-text">West Pune, Moshi</p>
            <div className="contact-links">
              <p><strong>Phone :</strong> +91 9371320616</p>
              <p><strong>Whatsapp :</strong> +91 9371320616</p>
            </div>
          </div>

        </div>

        {/* Disclaimer Section */}
        <div className="footer-disclaimer-box">
          <p>
            Disclaimer: The content is for informational purposes only and does not constitute an offer to avail of any service. 
            Prices mentioned are subject to change without notice. Images are for representation purposes only.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;